/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */

import { b as bootstrapLazy } from './index-21e7e84e.js';
export { s as setNonce } from './index-21e7e84e.js';
import { g as globalScripts } from './app-globals-0f993ce5.js';

const defineCustomElements = async (win, options) => {
  if (typeof window === 'undefined') return undefined;
  await globalScripts();
  return bootstrapLazy([["globalelem-cta-web-component_2",[[0,"globalelem-cta-web-component",{"modelseries":[1],"subbrand":[16],"scenario":[1],"icononly":[4],"size":[1],"direction":[1],"showprimaryonly":[4],"enquiryformurl":[1],"tracking":[4],"modernwb":[4],"darkmode":[4],"ctas":[32],"isLoading":[32],"isMobileView":[32],"hideLabel":[32],"isAnalyticsCalled":[32]}],[0,"globalelem-form",{"formUrl":[1,"form-url"],"contextData":[1,"context-data"],"renderForm":[32]},[[0,"wbclose","closeModal"]]]]]], options);
};

export { defineCustomElements };

//# sourceMappingURL=loader.js.map